import { render, staticRenderFns } from "./SubmissionNav.vue?vue&type=template&id=91ebbba0"
import script from "./SubmissionNav.vue?vue&type=script&lang=js"
export * from "./SubmissionNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports